import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function TermosDialog(props) {
    const open = props.open
    const scroll = 'body';

    const handleClose = props.close

    function checkTermos(){
        handleClose()
        props.checkTermos(true)
    }

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">POLÍTICA DE PRIVACIDADE</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                    >
                        Pelo presente instrumento o ITI INSTITUTO TECNOLÓGICO INOVAÇÃO divulga a sua Política de Privacidade e os seus Termos de Uso, assegurando a integridade e a segurança das informações pessoais identificáveis de seus usuários e colaboradores.
                        <br />
                        <br />
                        O usuário pode navegar pelo portal do ITI INSTITUTO TECNOLÓGICO INOVAÇÃO sem a necessidade de fornecer as suas informações pessoais, mas o seu acesso implica na concordância com as regras de uso e de privacidade fixadas no presente termo.
                        <br />
                        <br />
                        Para os serviços restritos, no entanto, poderá haver a requisição de dados do usuário. Neste caso, a instituição assegura o armazenamento das informações de maneira sigilosa, não as compartilhando com terceiros sem prévia autorização, exceto quando solicitado por autoridade judicial, em concordância com as definições e parâmetros da nova Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018).
                        <br />
                        <br />
                        Os conteúdos de terceiros ou as notícias produzidas pelos veículos de comunicação, reproduzidos no portal do ITI INSTITUTO TECNOLÓGICO INOVAÇÃO, são publicados mediante a autorização expressa dos seus envolvidos. As informações contidas neste site são protegidas pela Lei de Direitos Autorais, por isso, é expressamente vedada à sua utilização para o envio, distribuição, publicação ou divulgação sem a autorização da instituição. A reprodução indevida sujeita o infrator às penalidades previstas em lei.
                        <br />
                        <br />
                        Com a aceitação do presente termo, o usuário compromete-se a utilizar adequadamente as informações disponibilizadas, sujeitando-se à legislação vigente.
                        <br />
                        <br />
                        <br />
                        ©2020 – ITI INSTITUTO TECNOLÓGICO INOVAÇÃO - Todos os direitos reservados - Termos de Uso e Política de Privacidade

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={() => checkTermos()} color="primary">
                        Concordar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
